import { httpV1 as http } from '@/services/api';

export async function search(params = {}) {
  return http.get('/users/seller-blacklists', { params });
}

export async function include(payload) {
  return http.post('/users/seller-blacklists', payload);
}

export async function unblock(id, removedReason, name) {
  return http.post(`/users/seller-blacklists/${id}/unblock`, { removed_reason: removedReason, name });
}
